import { AUDIO_PLAYER_STATUS } from './audio-player-status';

export const checkStatus = (status) => {
  const isStatusIdle = status === AUDIO_PLAYER_STATUS.idle;
  const isStatusActive = status === AUDIO_PLAYER_STATUS.active;
  const isStatusInactive = status === AUDIO_PLAYER_STATUS.inactive;
  return { isStatusIdle, isStatusActive, isStatusInactive };
};
